import { Component } from '@angular/core';
import { ComissionSimulator } from '../../../components/comission-simulator/comission-simulator';

@Component({
  selector: 'app-report-simulator',
  imports: [ComissionSimulator],
  templateUrl: './simulator.html',
  styleUrl: './simulator.scss',
})
export class ReportSimulator {

}
